import TargetAudiencePage from './TargetAudiencePage';
import type { AudienceContent } from './TargetAudiencePage';

const content: { hr: AudienceContent; en: AudienceContent } = {
  hr: {
    meta: { title: 'Za iznajmljivače apartmana | BookiApp', description: 'BookiApp za male iznajmljivače s 1-3 apartmana. Smanjite pitanja gostiju, profesionalizirajte komunikaciju, uštedite 30+ sati godišnje.' },
    hero: { badge: 'ZA IZNAJMLJIVAČE', title: 'Imate 1-3 apartmana?', highlight: 'BookiApp je za vas.', subtitle: 'Prestanite odgovarati na ista pitanja. Dajte gostima profesionalnu aplikaciju s svim informacijama - za manje od cijene jedne večere godišnje.', image: '🏠' },
    painPoints: {
      title: 'Prepoznajete li ovo?',
      items: [
        'Gosti zovu u 23h za WiFi lozinku koju ste već poslali',
        'Svaki gost pita iste stvari - parking, check-out, restoran',
        'Objašnjavate upute za dolazak iznova svakom gostu',
        'Strani gosti ne razumiju vaše poruke na WhatsAppu',
        'Nemate vremena za individualizirane upute svakom gostu',
        'Loše recenzije zbog informacija koje su se "izgubile u porukama"',
      ],
    },
    solutions: {
      title: 'BookiApp rješava sve',
      subtitle: 'Jedan link za gosta - sve automatski',
      items: [
        { icon: 'smartphone', title: 'Aplikacija za svakog gosta', desc: 'WiFi, upute, pravila, parking - sve na jednom mjestu. Gost otvara link, nema instalacije.' },
        { icon: 'messages', title: 'Chat s prijevodom', desc: 'Pišete hrvatski, gost čita na svom jeziku. 95+ jezika, automatski.' },
        { icon: 'bell', title: 'Push obavijesti', desc: 'Obavijest kad gost krene, stigne ili pošalje poruku. Čak i kad ne gledate mobitel.' },
        { icon: 'calendar', title: 'Sinkronizacija kalendara', desc: 'Automatski sync s Booking.com i Airbnb. Nikad više dupla rezervacija.' },
        { icon: 'bot', title: 'AI asistent', desc: 'Odgovara gostima 24/7 koristeći podatke vašeg smještaja. Vi mirno spavate.' },
        { icon: 'map', title: 'Lokalne preporuke', desc: 'Podijelite omiljene restorane i plaže. Gost dobiva personalizirani vodič.' },
      ],
    },
    stats: [
      { value: '69 EUR', label: 'godišnje (Early Adopter)' },
      { value: '5 min', label: 'za postavljanje' },
      { value: '30+', label: 'sati uštede godišnje' },
      { value: '95+', label: 'podržanih jezika' },
    ],
    cta: { title: 'Pokrenite za 5 minuta', subtitle: 'Vaši gosti zaslužuju profesionalno iskustvo. Vi zaslužujete manje posla.', button: 'Započni sada' },
  },
  en: {
    meta: { title: 'For apartment hosts | BookiApp', description: 'BookiApp for small hosts with 1-3 apartments. Reduce guest questions, professionalize communication, save 30+ hours per year.' },
    hero: { badge: 'FOR HOSTS', title: 'Have 1-3 apartments?', highlight: 'BookiApp is for you.', subtitle: 'Stop answering the same questions. Give guests a professional app with all information - for less than the price of one dinner per year.', image: '🏠' },
    painPoints: {
      title: 'Sound familiar?',
      items: [
        'Guests call at 11 PM for WiFi password you already sent',
        'Every guest asks the same things - parking, check-out, restaurant',
        'Explaining arrival directions to every single guest',
        'Foreign guests don\'t understand your WhatsApp messages',
        'No time for individualized instructions for each guest',
        'Bad reviews because info "got lost in messages"',
      ],
    },
    solutions: {
      title: 'BookiApp solves everything',
      subtitle: 'One link for the guest - everything automatic',
      items: [
        { icon: 'smartphone', title: 'App for every guest', desc: 'WiFi, directions, rules, parking - all in one place. Guest opens a link, no install needed.' },
        { icon: 'messages', title: 'Translated chat', desc: 'You write in your language, guest reads in theirs. 95+ languages, automatic.' },
        { icon: 'bell', title: 'Push notifications', desc: 'Get notified when guest departs, arrives, or sends a message. Even when you\'re not looking at your phone.' },
        { icon: 'calendar', title: 'Calendar sync', desc: 'Auto-sync with Booking.com and Airbnb. Never double-book again.' },
        { icon: 'bot', title: 'AI assistant', desc: 'Answers guests 24/7 using your property data. You sleep peacefully.' },
        { icon: 'map', title: 'Local recommendations', desc: 'Share favorite restaurants and beaches. Guest gets a personalized guide.' },
      ],
    },
    stats: [
      { value: '69 EUR', label: 'per year (Early Adopter)' },
      { value: '5 min', label: 'to set up' },
      { value: '30+', label: 'hours saved per year' },
      { value: '95+', label: 'languages supported' },
    ],
    cta: { title: 'Launch in 5 minutes', subtitle: 'Your guests deserve a professional experience. You deserve less work.', button: 'Get started' },
  },
};

export default function ZaIznajmljivacePage() {
  return <TargetAudiencePage content={content} canonical="/za-iznajmljivace" />;
}
